export default function CompanyResults() {
  const results = [
    { icon: 'ri-check-double-line', title: 'Единые управленческие стандарты', desc: 'Все руководители работают по общей системе, говорят на одном языке, используют одинаковые инструменты управления.' },
    { icon: 'ri-user-heart-line', title: 'Самостоятельность сотрудников', desc: 'Команда принимает решения и решает задачи без постоянного участия руководителя. Снижение нагрузки на управленцев.' },
    { icon: 'ri-line-chart-line', title: 'Снижение текучести', desc: 'Сотрудники остаются в компании, потому что работают с сильными руководителями, которые их развивают.' },
    { icon: 'ri-fire-line', title: 'Рост вовлечённости', desc: 'Команда работает с энергией и интересом. Инициатива снизу, а не только приказы сверху.' },
    { icon: 'ri-rocket-2-line', title: 'Быстрые решения', desc: 'Управленческие решения принимаются быстрее и качественнее. Меньше согласований и бюрократии.' },
    { icon: 'ri-emotion-happy-line', title: 'Меньше конфликтов', desc: 'Снижение количества деструктивных конфликтов. Конструктивное решение разногласий.' },
    { icon: 'ri-shield-check-line', title: 'Рост ответственности', desc: 'Руководители перестают перекладывать ответственность. Каждый отвечает за результат своего подразделения.' },
    { icon: 'ri-star-line', title: 'Руководители становятся лидерами', desc: 'Трансформация от «начальника» к «лидеру»: за руководителями идут добровольно, к их мнению прислушиваются.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие результаты получает компания
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Эффект от системного обучения руководителей выходит далеко за рамки индивидуального развития — меняется вся компания
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {results.map((result, i) => (
            <div key={i} className="bg-white p-6 rounded-xl hover:ring-2 hover:ring-teal-200 transition-all group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${result.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{result.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{result.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <div className="inline-block bg-teal-50 border border-teal-200 rounded-xl px-8 py-5">
            <p className="text-lg md:text-xl font-bold text-teal-800">
              Инвестиции в обучение руководителей окупаются через рост производительности всей команды
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}